import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { recipe } from "@vanilla-extract/recipes";

import { carouselStyle } from "../Carousel/Carousel.css";
import { theme } from "../../theme/css/theme.css";

export const containerStyle = style({
  overflow: "hidden",
});

export const gridNavigationStyle = style({
  position: "absolute",
  top: 0,
  right: 0,
  width: "100%",
  height: "100%",
  color: theme.colors.background,
});

export const blurImageStyle = style({
  filter: "blur(10px)",
  width: "110%",
  height: "110%",
  top: "-5%",
  left: "-5%",
  zIndex: 1,
  gridRow: "1 / -1",
  gridColumn: "1 / -1",
});

export const gridSelectedImageContainerStyle = style({
  display: "grid",
  gridArea: "1 / 1",
  width: "100%",
  aspectRatio: "16/9",
  overflow: "hidden",
  borderRadius: theme.borderRadiuses.s,
});

export const gridSelectedImageStyle = style({
  gridRow: "1 / -1",
  gridColumn: "1 / -1",
});

export const gridThumbnailStyle = recipe({
  base: {
    selectors: {
      [`${carouselStyle} &`]: {
        width: rem(120),
        aspectRatio: "4 / 3",
      },
    },
  },
});

export const fullCarouselStyle = style({});

export const fullImageStyle = recipe({
  base: {
    width: `calc(var(--container-width) - ${theme.spacings.m} * 2) !important`,
    aspectRatio: "4 / 3",
  },
  variants: {
    inactive: {
      true: {
        // transition: transition({ property: "transform" }),
        // transform: "scale(0.96)",
        // transformOrigin: "center top",
      },
      false: {
        // transition: transition("transform"),
        // transform: "scale(1)",
        // transformOrigin: "center top",
      },
    },
    placeholder: {
      true: {},
      false: {},
    },
  },
});

export const poiStyle = style({
  zIndex: 2,
});

export const poiContainerStyle = style({
  width: 0,
  height: 0,
  position: "absolute",
  zIndex: 2,
});
